import { z } from 'zod';

import {
  CmsUrl,
  CtaPosition,
  CtaSize,
  CtaStyle,
  CtaWidth,
  MarginStyle,
} from '../models';
import { BasePType } from './base';

export const CtaButton = BasePType.extend({
  type: z.enum(['ctaButton']),
  analyticsLinkText: z.string().nullable().optional(),
  buttonDisabledClass: z.string().nullable().optional(),
  chevron: z.boolean(),
  fontAwesomeIconClass: z.string().nullable().optional(),
  ctaPosition: z.nullable(CtaPosition).optional(),
  ctaSize: z.nullable(CtaSize).optional(),
  ctaWidth: z.nullable(CtaWidth).optional(),
  ctaStyle: z.nullable(CtaStyle).optional(),
  marginBottomClass: z.nullable(MarginStyle),
  marginTopClass: z.nullable(MarginStyle),
  url: z.nullable(CmsUrl),
  visibility: z
    .object({
      tid: z.number().optional(),
      name: z.string().optional(),
      visibilityClass: z.string().optional(),
    })
    .nullable(),
});

export type CtaButton = z.infer<typeof CtaButton>;
